import { Modal } from "components/modal";
import { Button } from "components/button";

interface ConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  type?: "danger" | "warning" | "info";
}

const DeleteConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  type = "warning",
}) => {
  const getIconColor = () => {
    switch (type) {
      case "danger":
        return "text-red-600";
      case "warning":
        return "text-yellow-600";
      case "info":
        return "text-blue-600";
      default:
        return "text-yellow-600";
    }
  };

  return (
    <Modal show={show} close={onClose} contentClassName="w-[90%] max-w-[450px] p-0 rounded-lg">
      <div className="p-6">
        <div className="flex items-start gap-4">
          <div className={`flex-shrink-0 ${getIconColor()}`}>
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-[#012169] mb-2">{title}</h3>
            <p className="text-sm text-[#667085]">{message}</p>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <Button
            type="outline"
            onClick={onClose}
            className="flex-1 h-11"
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            type="fill"
            onClick={onConfirm}
            className="flex-1 h-11 !bg-red-600 hover:!bg-red-700"
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { DeleteConfirmationModal };
